var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6695 1.70312C18.5699 1.6497 18.4576 1.62432 18.3446 1.62969C18.2317 1.63505 18.1223 1.67097 18.0281 1.73359L15.25 3.58203V1.625C15.25 1.29348 15.1183 0.975537 14.8839 0.741116C14.6495 0.506696 14.3315 0.375 14 0.375H1.5C1.16848 0.375 0.850537 0.506696 0.616116 0.741116C0.381696 0.975537 0.25 1.29348 0.25 1.625V10.375C0.25 10.7065 0.381696 11.0245 0.616116 11.2589C0.850537 11.4933 1.16848 11.625 1.5 11.625H14C14.3315 11.625 14.6495 11.4933 14.8839 11.2589C15.1183 11.0245 15.25 10.7065 15.25 10.375V8.42188L18.0281 10.2742C18.1313 10.3412 18.252 10.3763 18.375 10.375C18.5408 10.375 18.6997 10.3092 18.8169 10.1919C18.9342 10.0747 19 9.91576 19 9.75V2.25C18.9992 2.13755 18.9681 2.02739 18.9099 1.93114C18.8518 1.83489 18.7687 1.75612 18.6695 1.70312ZM14 10.375H1.5V1.625H14V10.375ZM17.75 8.58203L15.25 6.91563V5.08437L17.75 3.42188V8.58203Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.046efee0c15e23052c7f8e2b44c9fb5f.svg";
export { ForwardRef as ReactComponent };